import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Breadcrumb } from '../progress/contract-progress.component';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-contract-progress-contribution',
    templateUrl: './../progress/contract-progress.component.html',
    styleUrls: ['./../progress/contract-progress.component.scss'],
})
export class ContractProgressContributionComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    public percent = 0;

    @Input()
    public breadcrumbs: Breadcrumb[] = [
        { title: 'progress.contribution.request', percent: 33 },
        { title: 'progress.contribution.detail', percent: 66 },
        { title: 'progress.sign', percent: 100 },
    ];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
